module.exports = __webpack_public_path__ + "static/media/laser-dark.758bd7b6.svg";